import React, {useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { TransparentButton, SolidButton } from '../../../../library/button'
import StepsView from './steps-view'
import UploadContainer from './upload-container'
import ConfigureContainer from './configure-container'
import UploadingContainer from './final-container'
import Papa from 'papaparse'
import { Carousel } from 'react-bootstrap'
import { changeSingleContactListModal, requestAddCsvRecord } from '../../../../../redux/actions/single-contact-list'
import { sendErrorNotification } from '../../../../universal/notifications/notifications'
import { withRouter } from 'react-router'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = props => {

    const listId = props.match.params.id

	const dispatch = useDispatch()

	const modalState = useSelector(state => state.singleContactList.showModals.addCsvModal)
	const addLoading = useSelector(state => state.singleContactList.addCsvLoading)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    const [file, setFile] = useState(null)

    const [stepProgress, setStepProgress] = useState(0)
    const [parseResults, setParseResults] = useState({})
    const fieldOverrides = useSelector(state => state.singleContactList.fieldOverrides)

    const handleClose = () => {
		dispatch(changeSingleContactListModal({addCsvModal: false}))
	}
	
    const parseFile = file => {
        Papa.parse(file, {
            header: true,
            complete: (e) => handleParseResults(e),
            error: (e) => handleParseError(e)
        })
    }

    const handleParseError = e => {
        sendErrorNotification("Kunne ikke lese CSV-fil.")
        setParseResults({})
        setStepProgress(0)
        setFile(null)
    }

    const handleParseResults = result => {
        if(result && result.meta && result.meta.fields){
            setParseResults(result)
        }
    }

    const handleFileDrop = (file, e) => {
        if(file && file[0] && file[0].size <= 100000000){
            setFile(file[0])
            parseFile(file[0])
        } else {
            sendErrorNotification("Maks filstørrelse er 10MB.")
        }
	}

    const renderUploadProgress = () => {
        switch(stepProgress){
            case 0:
                return 5
            case 1:
                return 50
            case 2:
                return 100
            default:
                return 5
        }
    }

    const clickNextSlide = () => {
        switch(stepProgress){
            case 0:
                if(Object.keys(parseResults).length > 0){
                    setStepProgress(1)
                } else {
                    sendErrorNotification("Vennligst velg en CSV-fil.")
                }
            break;
            case 1:
                const changes = fieldOverrides && fieldOverrides.length
                const fields = parseResults && parseResults.meta && parseResults.meta.fields && parseResults.meta.fields.length

                if(changes === fields){
                    setStepProgress(2)
                    setTimeout(() => {
                        dispatch(requestAddCsvRecord({data: {overrides: fieldOverrides, rows: parseResults.data}, companyId: selectedCompany, listId: listId}))
                    }, 1000)
                } else {
                    sendErrorNotification("Vennligst oppdater alle rader.")
                }
            break;
            default:break
        }
    }
	
    return(
        <Popup
            onClose={handleClose}
            show={modalState} 
            title="Legg til i kontaktliste"
            description="Følg instruksjonene vist under for å laste opp en CSV-fil og konfigurere riktig datasett."
            buttons={[
                <TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
                <SolidButton onClick={() => clickNextSlide()} color="blue" title="Gå videre" type="button"/>
            ]}	
        >
            <div className="add-csv-content-container">
                <StepsView stepProgress={stepProgress} renderUploadProgress={renderUploadProgress}/>
                <div className="modal-content-container">
                    <Carousel activeIndex={stepProgress} indicators={false} controls={false}>
					    <Carousel.Item className="selection-item">
                            <UploadContainer handleFileDrop={handleFileDrop} parseData={parseResults} file={file}/>
						</Carousel.Item>
						<Carousel.Item className="selection-item">
							<ConfigureContainer parseData={parseResults}/>
						</Carousel.Item>
                        <Carousel.Item className="selection-item">
                            <UploadingContainer/>
                        </Carousel.Item>
					</Carousel>
                </div>
            </div>
            <ToastContainer/>
        </Popup>
    )
}

export default withRouter(Index)

